import React, {Component} from 'react';
import * as R from 'ramda';
import {ENUMS} from 'js/common';
import {CardStyles} from 'js/campaign_analytics/v2/campaign_analytics_page/posts/posts_controls_row/controls_helper';

// Components
import PostGridItem from 'js/campaign_analytics/v2/campaign_analytics_page/posts/post_grid_item';
import ImageModal from 'js/campaign_analytics/v2/campaign_analytics_page/posts/image_modal';
import VideoModal from 'js/campaign_analytics/v2/campaign_analytics_page/posts/video_modal';

class ContentLeaderboardImagesContainer extends Component {
    displayPosts = () => {
        const {leaderboardContent, showKoer, showVideoViews} = this.props;

        if (R.isEmpty(leaderboardContent)) {
            return <div>No Items to Display</div>;
        }
        return leaderboardContent.map(post => (
            <PostGridItem
                currentCardSize={CardStyles.SMALL}
                post={post}
                koer={post.koer}
                showKoer={showKoer}
                showViews={showVideoViews}
                setPostScore={() => {}}
                showPostScore={false}
                setSelectedPost={this.props.setSelectedPost}
                renderForPdf={this.props.renderForPdf}
                key={post.content_metadata_id}
            />
        ));
    };

    displayModal = () => {
        const {selectedPost} = this.props;
        const noneSelected = !R.has('content_distribution_metadata')(selectedPost);
        if (noneSelected) return null;

        const modalProps = {
            show: this.props.showContentModal,
            close: this.props.closeContentModal,
            downloadUrl: this.props.downloadUrl,
            isAdmin: this.props.isAdmin,
            post: selectedPost,
            setPostScore: () => {},
            showPostScore: false,
            handleDownloadContent: () => {},
            shareOptions: {}
        };

        if (selectedPost.content_type === ENUMS.ContentType.IMAGE) {
            return <ImageModal {...modalProps} />;
        }
        return <VideoModal {...modalProps} />;
    };

    render() {
        const {renderForPdf} = this.props;

        const posts = this.displayPosts();
        const modal = this.displayModal();

        return (
            <div className="content-leaderboard-images-container">
                {posts}
                {modal}

                {/*STYLES*/}

                <style>{`
                    .post:before {
                        content: no-open-quote;
                        float: left;
                        padding-top: 100%;
                    }

                    .post:after {
                        content: no-close-quote;
                    }

                    .post {
                        background-size: cover;
                        background-position: center;
                        background-repeat: no-repeat;
                        background-color: white;
                        width: 300px;
                        height: 300px;
                        margin: 4px;
                        position: relative;
                        border-radius: 20px;
                        cursor: pointer;
                        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
                    }
                    .post.video {
                        background-size: contain;
                        background-position: center;
                        background-color: black;
                    }
                    .post:hover .play-button {
                        display: none;
                    }
                    .post .play-button-overlay {
                        background: url("/images/icons/play_icon.png") no-repeat center;
                        background-size: 50px;
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                    }
                    .post .post-overlay {
                        border-radius: 20px;
                        position: absolute;
                        top: 0;
                        right: 0;
                        bottom: 0;
                        left: 0;
                        background-color: rgba(0, 0, 0, 0.5);
                        display: none;
                        flex-direction: column;
                        align-items: center;
                    }
                    .post .post-overlay .engagement-rate {
                        text-align: center;
                        color: white;
                        margin: auto;
                    }
                    .post .post-overlay .engagement-rate div:first-child {
                        font-size: 52px;
                    }
                    .post .post-overlay .engagement-rate div:nth-child(2) {
                        font-size: 20px;
                        padding-bottom: 5px;
                    }
                    .post .post-overlay .engagement-rate .star-rating a {
                        font-size: 14px;
                    }
                    .post .post-overlay .engagement-rate .engagement-rate-sm div:first-child {
                        font-size: 30px;
                    }
                    .post .post-overlay .engagement-rate .engagement-rate-sm div:nth-child(2) {
                        font-size: 14px;
                        padding-bottom: 0;
                    }
                    .post .post-overlay .username {
                        position: absolute;
                        left: 16px;
                        bottom: 32px;
                        color: white;
                        font-size: 20px;
                    }
                    .post .post-overlay .username .profile-picture {
                        width: 70px;
                        height: 70px;
                        border-radius: 40px;
                        background-size: cover;
                        margin-right: 10px;
                    }
                    .post .post-overlay .username .username-info {
                        margin-bottom: auto;
                    }
                    .post .post-overlay .username div:last-child div {
                        font-size: 60%;
                    }
                    .post .post-overlay .feature {
                        position: absolute;
                        left: 16px;
                        top: 16px;
                    }
                    .post .post-overlay .rating {
                        position: absolute;
                        right: 16px;
                        top: 16px;
                    }
                    .post .post-overlay .post-metric {
                        color: white;
                        font-size: 20px;
                    }
                    .post .post-overlay .likes {
                        position: absolute;
                        left: 16px;
                        bottom: 16px;
                        border-radius: 0;
                        background-color: transparent;
                        opacity: 1.0;
                    }
                    .post .post-overlay .comments {
                        position: absolute;
                        right: 16px;
                        bottom: 16px;
                        border-radius: 0;
                        background-color: transparent;
                        opacity: 1.0;
                    }
                    .post .post-overlay .likes-comments {
                        position: absolute;
                        right: 16px;
                        bottom: 16px;
                    }
                    .post .post-overlay .likes-comments i {
                        padding: 0px 4px;
                    }
                    .post .post-overlay .views {
                        position: absolute;
                        left: 16px;
                        bottom: 16px;
                        border-radius: 0;
                        background-color: transparent;
                        opacity: 1.0;
                    }
                    .post .post-overlay .screenshots {
                        position: absolute;
                        right: 16px;
                        bottom: 16px;
                        border-radius: 0;
                        background-color: transparent;
                        opacity: 1.0;
                    }
                    .post.small {
                        height: auto;
                        width: 24%;
                        font-size: 100%;
                    }
                    .post.small:hover .post-overlay .engagement-rate div:first-child {
                        font-size: 30px;
                    }
                    .post.small:hover .post-overlay .engagement-rate div:nth-child(2) {
                        font-size: 15px;
                        padding-bottom: 2px;
                    }
                    .post.small:hover .post-overlay .engagement-rate .star-rating a {
                        font-size: 14px;
                    }
                    .post.small:hover .post-overlay .engagement-rate .engagement-rate-sm div:first-child {
                        font-size: 18px;
                    }
                    .post.small:hover .post-overlay .engagement-rate .engagement-rate-sm div:nth-child(2) {
                        font-size: 12px;
                        padding-bottom: 0;
                    }
                    .post.small:hover .post-overlay .username {
                        font-size: 12px;
                    }
                    .post.small:hover .post-overlay .username .profile-picture {
                        display: none;
                    }
                    .post.small:hover .post-overlay .username div:last-child div {
                        display: none;
                    }
                    .post.small:hover .post-overlay .post-metric {
                        font-size: 16px;
                    }

                    .content-leaderboard-images-container {
                        padding: 20px 0px;
                    }
                `}</style>

                {/*STYLE FOR WEB*/}
                {!renderForPdf ? (
                    <style>{`
                        .content-leaderboard-images-container {
                            display: flex;
                            justify-content: center;
                            flex-wrap: wrap;
                        }

                        .post:hover .post-overlay {
                            display: flex;
                        }

                        .post .post-overlay .username {
                            display: flex;
                            justify-content: space-between;
                        }
                    `}</style>
                ) : null}

                {/*STYLE FOR PDF*/}
                {renderForPdf ? (
                    <style>{`
                        .content-leaderboard-images-container {
                            text-align: center;
                        }

                        .post {
                            display: inline-block;
                        }

                        .post-overlay {
                            display: inline !important;
                            position: absolute;
                            top: 0;
                            left: 0;
                        }

                        .post-overlay .engagement-rate {
                            position: relative;
                            top: 80px;
                        }

                        .post .post-overlay .engagement-rate div:first-child {
                            font-size: 26px;
                        }

                        .post .post-overlay .engagement-rate div:nth-child(2) {
                            font-size: 20px;
                            padding-bottom: 5px;
                        }

                        .post .post-overlay .post-metric {
                            font-size: 14px;
                        }

                        .post-overlay .username .profile-picture {
                            display: none;
                        }

                        .post .post-overlay .username {
                            font-size: 10px;
                        }

                        .post-overlay .username .username-info .formatted-date {
                            display: none;
                        }
                    `}</style>
                ) : null}
            </div>
        );
    }
}

ContentLeaderboardImagesContainer.propTypes = {};

export default ContentLeaderboardImagesContainer;



// WEBPACK FOOTER //
// ./campaign_analytics/campaign_wrap_up/content_leaderboard/content_leaderboard_images_container.js